import { Injectable } from '@angular/core';
import { STORAGE_CONST } from '@app/core/constants/storage-constants';
import { Preferences } from '@capacitor/preferences';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  constructor() {}

  async getSessionKey(): Promise<any> {
    try {
      return await this.get(STORAGE_CONST.SESSION_KEY);
    } catch (error) {
      console.error(error);
    }
  }

  async setSessionKey(sessionKey: string) {
    try {
      await this.set(STORAGE_CONST.SESSION_KEY, sessionKey);
    } catch (error) {
      console.error(error);
    }
  }

  async get(key: string): Promise<any> {
    try {
      const { value } = await Preferences.get({ key });
      // const decryptedValue = value ? await this.decrypt(value) : undefined;
      const decryptedValue = value !== 'undefined' ? value : undefined;
      return decryptedValue;
    } catch (error) {
      console.error(error);
    }
  }

  async getJson(key: string): Promise<any> {
    try {
      const { value } = await Preferences.get({ key });
      // const decryptedValue = value ? await this.decrypt(value) : undefined;
      const decryptedValue = value !== 'undefined' ? value : undefined;
      // return decryptedValue;
      return decryptedValue ? JSON.parse(decryptedValue) : undefined;
    } catch (error) {
      console.error(error);
    }
  }

  async set(key: string, value: any): Promise<any> {
    try {
      // const encryptedValue = value ? await this.encrypt(value) : undefined;
      const encryptedValue = value ? value : undefined;
      await Preferences.set({ key, value: encryptedValue });
    } catch (error) {
      console.error(error);
    }
  }

  async setJson(key: string, value: any): Promise<any> {
    try {
      // const encryptedValue = value ? await this.encrypt(value) : undefined;
      let encryptedValue = value ? value : undefined;
      encryptedValue = JSON.stringify(encryptedValue);
      await Preferences.set({ key, value: encryptedValue });
    } catch (error) {
      console.error(error);
    }
  }

  async removeSession(): Promise<any> {
    try {
      return await Preferences.remove({ key: STORAGE_CONST.SESSION_KEY });
    } catch (error) {
      console.error(error);
    }
  }

  async remove(key: string): Promise<any> {
    try {
      return await Preferences.remove({ key });
    } catch (error) {
      console.error(error);
    }
  }

  async clear(): Promise<void> {
    try {
      return await Preferences.clear();
    } catch (error) {
      console.error(error);
    }
  }

  async keys(): Promise<Array<string>> {
    try {
      return (await Preferences.keys()).keys;
    } catch (error) {
      console.error(error);
    }
    return []
  }

  currentTimestamp(): number {
    return Math.floor(new Date().getTime() / 1000);
  }
}
